module.exports = __webpack_public_path__ + "static/img/bangka.71735aa3.jpg";